import { useState } from "react";
import { Card, Button, Tabs, Flex } from "antd";
import PortfoliosCawler from "./PortfolioCawler";
import AddPortfolios from "./AddPortfolios";
import TimePortfolios from "./TimePortfolios";
import ListPortfolios from "./ListPortfolios";
import useWindowSize from "../../../hooks/useWindowSize";

const FundsPortfolio = () => {
  const { isMobileView } = useWindowSize();
  const [isVisible, setIsVisible] = useState(false);
  const [isCawlerForm, setIsCawlerForm] = useState(false);
  const [isReloadList, setIsReloadList] = useState(false);

  const handleCloseModal = (isReload) => {
    if (isReload) {
      setIsReloadList((prevIsReloadList) => !prevIsReloadList);
    }
    setIsVisible(false);
    setIsCawlerForm(false);
  };

  const items = [
    {
      key: "1",
      label: <b>Thống kê theo thời gian</b>,
      children: <TimePortfolios isReload={isReloadList} />,
    },
    {
      key: "2",
      label: <b>Thống kê theo quỹ</b>,
      children: <ListPortfolios isReload={isReloadList} />,
    },
  ];

  return (
    <Card
      bordered={false}
      title={<b className="form-title">Danh mục đầu tư các quỹ</b>}
      styles={{ body: { padding: "0 4px" } }}
      extra={
        <Flex gap={12}>
          <Button size="small" onClick={() => setIsVisible(true)}>
            Import
          </Button>
          <Button size="small" onClick={() => setIsCawlerForm(true)}>
            Cawl Data
          </Button>
        </Flex>
        
      }>
      {isVisible && <AddPortfolios isOpenModal={isVisible} onClose={handleCloseModal} />}
      {isCawlerForm && <PortfoliosCawler isOpenModal={isCawlerForm} onClose={handleCloseModal} />}

      <Tabs
        size="small"
        defaultActiveKey="1"
        items={items}
        style={{ padding: isMobileView ? "0 0.25rem" : "0 1.5rem", margin: 0 }}
        tabBarStyle={{ margin: 0 }}
      />
    </Card>
  );
};

export default FundsPortfolio;
